import stock from './stock'
import sales from './sales'
import warehouse from './warehouse'
import account from './account'
import order from './order'
import logisticscompany from './logisticscompany'
import stockCheck from './stockCheck'

export default {
  ims: {
    ...stock,
    ...sales,
    ...warehouse,
    ...account,
    ...order,
    ...logisticscompany,
    ...stockCheck
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/ims/ims.js